/* eslint-disable no-nested-ternary */
import { MessageOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React, { useContext, useState } from 'react';
import EmpresaContext from '../context/empresa-context';

const BotonSiguiente = (props) => {
  const {
    principalLoading,
    telefonica,
    viaje,
    tipoVenta,
    personaViaContacto,
    noEsCliente
  } = props;
  const [loadingFirmar, setLoadingFirma] = useState();
  const [loadingSms, setLoadingSms] = useState();
  const [loadingMail, setLoadingMail] = useState();
  const { empresa } = useContext(EmpresaContext);

  const puedeEnviarEnlace = !viaje && tipoVenta !== 'presencial' && noEsCliente;
  const textoTooltip = puedeEnviarEnlace
    ? 'Seguir en la página y firmar documentos'
    : '';

  const solicitar = async (type) => {
    props.solicitar(type);
  };
  return (
    <>
      <Tooltip title={viaje ? 'Finalizar solicitud' : textoTooltip}>
        <Button
          type="primary"
          style={{ margin: 10 }}
          loading={loadingFirmar && principalLoading}
          disabled={(loadingSms || loadingMail) && principalLoading}
          onClick={() => {
            setLoadingFirma(true);
            solicitar('f');
          }}
        >
          {telefonica
            ? 'Aprobar solicitud'
            : viaje
            ? 'Solicitar'
            : 'Firmar documentos'}
        </Button>
      </Tooltip>
      {puedeEnviarEnlace && (
        <Tooltip
          title={
            empresa.tiene_sms
              ? `Enviar por ${
                  personaViaContacto === 'whatsapp' ? 'Whatsapp' : 'SMS'
                } el enlace para firmar`
              : 'Enviar por Correo el enlace para firmar'
          }
        >
          <Button
            type="dashed"
            style={{ margin: 10 }}
            onClick={() => {
              if (empresa.tiene_sms) {
                setLoadingSms(true);
                solicitar('sms');
              } else {
                setLoadingMail(true);
                solicitar('mail');
              }
            }}
            icon={<MessageOutlined />}
            loading={(loadingSms || loadingMail) && principalLoading}
            disabled={loadingFirmar && principalLoading}
          >
            {empresa.tiene_sms || empresa.tiene_whatsapp
              ? `Enviar ${
                  empresa.tiene_whatsapp && personaViaContacto === 'whatsapp'
                    ? 'Whatsapp'
                    : 'SMS'
                } para firmar`
              : `Enviar Correo para firmar`}
          </Button>
        </Tooltip>
      )}
    </>
  );
};

export default BotonSiguiente;
